import React from 'react';
import styles from './Form.module.css';

export interface FormToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

const FormToggle: React.FC<FormToggleProps> = ({ 
  checked, 
  onChange, 
  label,
  disabled = false,
  className = '' 
}) => {
  return (
    <label className={`${styles.toggleLabel} ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className={styles.toggle}
      />
      {label && <span className={styles.toggleText}>{label}</span>}
    </label>
  );
};

export default FormToggle;

